import api from './api';

/**
 * @returns {Promise<{
 *  target_template_id: string
 *  name: string
 *  primary_targets: string[] | null
 *  secondary_targets: string[] | null
 *  distractor_targets: string[] | null
 * }[]>}
 */
export default async function getAutomarkerTargetTemplates() {
    const { data } = await api.get('target_templates');

    return data;
}